.scrollbox {
    height: fit-content;
    overflow: auto;
    /* padding: 0 var(--mantine-spacing-xl); */
    scrollbar-color: var(--mantine-color-gray-4) var(--mantine-color-gray-1);
    scrollbar-width: thin;
    scrollbar-gutter: stable;
}

.scrollboxLight {
    scrollbar-color: var(--mantine-color-gray-2) white;
    scrollbar-width: thin;
    scrollbar-gutter: stable;
}

.scrollboxDark {
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
    scrollbar-width: thin;
    scrollbar-gutter: stable;
}

.scrollboxLightThick {
    height: fit-content;
    overflow: auto;
    scrollbar-color: var(--mantine-color-gray-2) white;
    scrollbar-width: thin;
    scrollbar-gutter: stable;
    flex-shrink: 0;
}

.smoothScroll {
    scroll-behavior: smooth;
}
